import PropTypes from 'prop-types';
import { getContext } from 'recompose';

export default getContext({ extension: PropTypes.object });



// WEBPACK FOOTER //
// ./src/app/notifications/hoc/withExtensionContextConsumer.js